<template>
    <div id="role_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="roleHeader" v-if="$route.params.id > 0">Update Role</span>
                    <span class="page-title" id="roleHeader" v-else>Add Role</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackRoleList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content role-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="RoleForm">
                                <div class="form-row">
                                    <div class="col-md-4">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Role Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                  <div class="col-md-4">
                                    <label class="control-label require" for="name">Role Identifier:</label>
                                    <input type="text" class="form-control" v-model="slug" id="name"  name="slug" disabled>
                                    <div class="field-error">{{slug_error_msg}}</div>
                                  </div>
                                    <div class="col-md-4">
                                        <label class="control-label">Landing Page:</label>
                                            <v-select id="landingpage" v-model="landingpage" name="landingpage" placeholder="Select Type." label="text"
                                                class="close-remove"
                                                :options='[{text:"Service",value:"service"},{text:"Lease",value:"lease"},{text:"Rental",value:"rental"},{text:"Account",value:"account"},{text:"Dashboard",value:"dashboard"}]'>
                                            </v-select>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="control-label require" for="name">Is Corporate:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="po_required"> Yes
                                                    <input type="radio" v-model="isCorporate" :value="1" id="is_corporate" name="is_corporate">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="po_required2"> No
                                                    <input type="radio" v-model="isCorporate" :value="0" id="is_corporate1" name="is_corporate">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createRoleBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateRole" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createRoleBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateRole" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueRoleBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateRole(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelRoleBtn" class="btn btn-tertiary" v-on:click.prevent="BackRoleList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "RoleCreate",

  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Role | " +process.env.COPYRIGHT_NAME : "Create Role | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    name: "",
    loading:false,
     permissions: [],
    cantAccessPage: "",
    name_error_msg: "",
    isCorporate:0,
    slug_error_msg: "Generated automatically based on the role name when the role is created!",
    slug: "",
    landingpage :{value:"dashboard",text:"Dashboard"},
  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_role') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
         setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {

                self.loadRole();

            }
        }, 100);
  },
  methods: {

    BackRoleList() {
      var self = this;
      self.$router.push("/roles/list");
    },

    CreateRole(flag) {
      var self = this;

      self.name_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (self.name_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createRoleBtn").val("Updating ...");
                $("#createRoleBtn").prop("disabled", true);
                $("#cancelRoleBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueRoleBtn").val("Saving ...");
                    $("#createRoleBtn").prop("disabled", true);
                    $("#createAndContinueRoleBtn").prop("disabled", true);
                    $("#cancelRoleBtn").prop("disabled",true);

                }else{

                    $("#createRoleBtn").val("Saving ...");
                    $("#createRoleBtn").prop("disabled", true);
                    $("#createAndContinueRoleBtn").prop("disabled", true);
                    $("#cancelRoleBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/role/create",
                type: "POST",
                data: {name: self.name, id: segments[3], is_corporate: self.isCorporate ,landingpage: self.landingpage.value},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createRoleBtn").val("Update");
                        $("#createRoleBtn").prop("disabled", false);
                        $("#cancelRoleBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueRoleBtn").val("Save and Continue");
                            $("#createRoleBtn").prop("disabled", false);
                            $("#createAndContinueRoleBtn").prop("disabled", false);
                            $("#cancelRoleBtn").prop("disabled",false);

                        }else{

                            $("#createRoleBtn").val("Save");
                            $("#createRoleBtn").prop("disabled", false);
                            $("#createAndContinueRoleBtn").prop("disabled", false);
                            $("#cancelRoleBtn").prop("disabled",false);
                        }

                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#RoleForm").trigger("reset");
                            self.name = "";

                        }else{
                            self.$router.push("/roles/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createRoleBtn").val("Update");
                        $("#createRoleBtn").prop("disabled", false);
                        $("#cancelRoleBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#RoleForm").trigger("reset");
                            self.name = "";
                            $("#createAndContinueRoleBtn").val("Save and Continue");
                            $("#createRoleBtn").prop("disabled", false);
                            $("#createAndContinueRoleBtn").prop("disabled", false);
                            $("#cancelRoleBtn").prop("disabled",false);

                        }else{

                            $("#createRoleBtn").val("Save");
                            $("#createRoleBtn").prop("disabled", false);
                            $("#createAndContinueRoleBtn").prop("disabled", false);
                            $("#cancelRoleBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'role-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }


    },

    loadRole() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/role/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.isCorporate = data.content.is_corporate;
                    self.slug = data.content.slug;
                    self.landingpage = {value:data.content.landingpage.toLowerCase(),text:data.content.landingpage[0].toUpperCase()+ data.content.landingpage.slice(1)};
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'role-by-id')
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RoleCreate.vue